// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { AssetCard } from './assetCard.zod.ts';

export const AssetListOut = zod.object({
  "assets": zod.array(AssetCard),
  "page": zod.int(),
  "page_size": zod.int(),
  "total": zod.int()
});

export type AssetListOut = zod.input<typeof AssetListOut>;
export type AssetListOutOutput = zod.output<typeof AssetListOut>;
